var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"suaw-list"},[_vm._l((_vm.items),function(item,index){return _c('ListItem',{key:index,attrs:{"item":item,"item-clickable":_vm.itemClickable},on:{"item-click":function($event){return _vm.itemClicked(item)},"button-click":function($event){return _vm.$emit('button-click', $event)}}})}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }